export const createVersionExpression = (versionString) => {
  if (versionString.includes('*')) {
    return versionString;
  }

  return versionString.split('.').slice(0, 1).concat('*').join('.');
};
